<template>
  <div>
    <single-setting
      id="slack-settings"
      class="single-setting"
      :icon="icon"
      :title="systemFullName(system)"  
      :warning="warning"
      :description="description"
    >
      <div class="user-count">{{ titleDetails }}</div>
      <button
        v-if="!isRightAfterInstallation && (integrationStatus === 'authorized' || integrationStatus === 'primaryOwnerNotFound')"
        class="clavo-button secondary user-sync-btn"
        @click="$emit('connect-users-clicked', system)"
      >
        {{ $t('integrationUsersConnect', { system: systemFullName(system) }) }}
      </button>
      
      <div v-if="!integrationStatus" class="integration-description">
        <ul>
          <li v-for="el in Object.keys(featuresList)" :key="el">{{ featuresList[el] }}</li>
        </ul>
        <button class="clavo-button secondary" @click="$emit('connect-clicked', system)">
          {{ $t('connect') }}
        </button>
      </div>
      <!-- Disconnect moved to the below settings section -->
      <!-- <button v-else class="clavo-button clavo-button-danger-secondary" @click="$emit('disconnect-clicked', system)">
        {{ $t('disconnect') }}
      </button> -->
      
    </single-setting>
    <single-setting
      v-if="integrationStatus && integrationSettings && Object.keys(integrationSettings).length"
      id="slack-toggles"
      class="single-setting single-setting-preferences"
      :description="settingsTitle"
    >
      <template #one-column-no-gaps>
        <div class="toggles-wrapper">
          <toggle
            v-for="el in Object.keys(integrationSettings)"
            :key="el"
            :name="integrationToggleSettings()[el]"
            :value="integrationSettings[el]"
            class="toggle"
            @toggled="updateintegrationSettings(el)"
          />
        </div>
        <button class="clavo-button clavo-button-danger-secondary disconnect-btn" @click="$emit('disconnect-clicked', system)">
          {{ $t('disconnect') }}
        </button>        
      </template>
    </single-setting>
  </div>
</template>

<script>
import Constants from '@/components/Constants'
import Validation from '@/components/Validation'
import SingleSetting from '@/components/Settings/SingleSetting'
import Toggle from '@/components/UI/Toggle.vue'
import ParseFunctions from '@/components/ParseFunctions'
const { systemFullName } = require('../../../../clavo-shared/constants/index')

export default {
  components: {
    SingleSetting,
    Toggle,
  },
  mixins: [Constants, Validation, ParseFunctions],
  props: {
    team: { type: Object, default: undefined },
    system: { type: String, default: undefined },
    icon: { type: String, default: undefined },
    settingsTitle: { type: String, default: undefined },
    activeMembersCount: { type: Number, default: 0 },
    description: { type: String, default: undefined },
    integrations: { type: Object, default: undefined },
    featuresList: { type: Array, default: undefined },
    warning: { type: String, default: undefined },
  },
  data() {
    return {
      isRightAfterInstallation: false,
    }
  },

  computed: {
    integrationSettings() {
      return this.integrations[this.system].settings
    },
    integrationStatus() {
      return this.integrations[this.system] ? this.integrations[this.system]._status : false
    },
    integrationConnected() {
      return this.integrations[this.system] ? true : false
    },
    titleDetails() {
      let integration = this.integrations[this.system]
      if (integration) {
        let integratedCount = this.integrations[this.system]['_integrated-count']
        let activeMembersCount = this.activeMembersCount
        return this.$tc('integrationCountOf', activeMembersCount, { integratedCount, activeMembersCount })
      } else {
        return undefined
      }
    },
  },
  methods: {
    async updateintegrationSettings(el) {
      this.integrationSettings[el] = !this.integrationSettings[el]

      const res = await this.setIntegrationSettings(this.team.teamId, this.system, this.integrationSettings)
      if (res.status !== 'ok') {
        this.showServerError(res)
      }
    },
    integrationToggleSettings() {
      return {
        'missed-deadline': this.$t('integrationMissedDeadline'),
        'me-missed-deadline': this.$t('integrationMeMissedDeadline'),
        'change-statuses': this.$t('integrationChangeStatuses', { system: systemFullName(this.system) }),
      }
    },
    systemFullName(system) {
      return systemFullName(system)
    },
  },
}
</script>

<style lang="scss" scoped>
section {
  .single-setting {
    margin-bottom: 60px;
    button {
      justify-self: start;
      align-self: flex-start;
    }
    .user-count {
      font-family: $bold;
      font-size: 14px;
      grid-column: 1/3;
      margin-top: -12px;
    }
    .user-sync-btn {
      grid-column: 1/4;
    }
    .integration-description {
      grid-column: 1/4;
      font-size: 14px;
      color: $amethyst;
      display: flex;
      flex-direction: column;
      ul {
        margin-top: -30px;
        margin-bottom: 30px;
      }
    }
    #input-name-wrapper {
      grid-column: 1 / span 2;
    }
    .toggles-wrapper {
      margin-top: -20px;
      .toggle {
        margin-bottom: 0px;
      }
    }
  }
  .single-setting-preferences {
    margin-top: -24px;
  }
}

@include respond-below(sm) {
  section {
    .single-setting {
      button {
        align-self: stretch;
        flex: 1;
        min-width: 0px;
        margin-bottom: 20px;
        &:last-of-type {
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>
